module.exports = __webpack_public_path__ + "static/010-7b249a5ce0568693e11bce925dc28ebe.png";